/**
 * Post ID Utility Functions
 * Handles extracting post ID from body class
 */

// Function to extract post ID from the body class
function getPostIdFromBodyClass() {
	const bodyClasses = jQuery('body').attr('class');
	const postIdRegex = /postid-(\d+)/;
	const match = bodyClasses.match(postIdRegex);
	if (match && match[1]) {
		return parseInt(match[1], 10); // Return the post ID as an integer
	}
	return null;
}
